import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import engine from '../Support/Engine';

import Cluster from '../Support/Cluster';
import Loader from '../UI/Loader';
import Processing from '../UI/Processing';

import Header from '../Blocks/Header';
import MatterForm from '../Blocks/MatterForm';


class NewMatter extends Component {

	state = {
		sending_email: false
	};

	componentDidMount() {
		if(this.props.user !== null && this.props.token !== null) {
			this.props.rdxNewMatter(this.props.token);
		}
	}

	saveMeasures = () => {
		this.props.rdxSaveMeasures(this.props.token,this.props.matter.id,this.props.measures,this.props.matter.has_counter,this.props.matter.angle);
	}

	sendEmail = () => {
		this.setState({sending_email: true});
		engine.post('/matter/email', {tk: this.props.token, c: this.props.matter.code})
			.then(response => {
				if(response.data.result) {
					this.props.rdxToast('An email has been sent to your account', 'positive');
				}
				else {
					this.props.rdxToast('Sorry, we were unable to send the email', 'negative');
				}
				this.setState({sending_email: false});
			})
			.catch(error => {
				this.props.rdxToast('Sorry, we were unable to send the email', 'negative');
				console.log(error);
			});
	}

	render() {

		if(this.props.user === null) {
			return <Redirect to='/' />;
		}

		let content = <Loader />;

		if(this.props.matter) {

			if(this.props.matter.redirect_from_new === true) {
				return <Redirect to={'/matter/' + this.props.matter.code} />;
			}

			let cc_btn = 'huge-btn huge-btn--brown';
			if(this.props.matter.has_counter) cc_btn = 'huge-btn huge-btn--soft';

			let calc_btn = <button className='huge-btn' onClick={this.saveMeasures}>Calculate <i className='fas fa-angle-right'></i></button>;
			if(this.props.matter.measure_saving) calc_btn = <Processing />;

			let email_label = <label>Email matter ID</label>;
			if(this.state.sending_email) email_label = <label className='dotdotdot'>Sending</label>;

			content = (
				<div className='new-matter'>

					<div className='new-matter__header'>
						<div className='wrapper'>

							<h5>Your new matter ID is</h5>

							<h4>{this.props.matter.code}</h4>

							<h3>Remember this ID</h3>

							<div className='screen-only'>

								<p>There are 3 ways for you to remember this ID.<br/>1. Save as a PDF to your device.*<br/>2. Email the Matter ID to your Username address.<br/>3. Print the Matter ID to your local printer.<br/>You can save, email or print at any time during this session.</p>

								<p className='subnote'>*This option brings up the print window where you can select "Save as PDF" instead of your printer.</p>

								<ul className='iconlist'>
									<li className='iconlist__item' onClick={() => window.print()}><i className='fas fa-file-pdf'></i><label>Save as PDF</label></li>
									<li className='iconlist__item' onClick={() => this.sendEmail()}><i className='fas fa-at'></i>{email_label}</li>
									<li className='iconlist__item' onClick={() => window.print()}><i className='fas fa-print'></i><label>Print matter ID</label></li>
								</ul>

								<div className='new-matter__angle'>
									<p className='new-matter__angle__label'>Are you a representative of the</p>
									<ul className='new-matter__angle__options'>
										<li className='new-matter__angle__option'>
											<button className={this.props.matter.angle === 'plaintiff' ? 'btn btn--toggle btn--orange btn--on' : 'btn btn--toggle btn--orange'}
												onClick={() => this.props.rdxSetMatterValue('angle', 'plaintiff')}>Plaintiff <i className='fas fa-paperclip btn--toggle__icon'></i></button>
										</li>
										<li className='new-matter__angle__option'>
											<button className={this.props.matter.angle === 'defendant' ? 'btn btn--toggle btn--blue btn--on' : 'btn btn--toggle btn--blue'}
												onClick={() => this.props.rdxSetMatterValue('angle', 'defendant')}>Defendant <i className='fas fa-paperclip btn--toggle__icon'></i></button>
										</li>
									</ul>
								</div>

							</div>

						</div>
					</div>

					<div className='new-matter__form screen-only'>

						<div className='wrapper'>

							<MatterForm />

							<div className='new-matter__footer'>
								<div className='pull-left--small'>
									<button className={cc_btn} onClick={this.props.rdxToggleCounterClaim}>{this.props.matter.has_counter ? 'Remove' : 'Add'} Counter Claim</button>
								</div>
								<div className='pull-right--small'>
									{calc_btn}
								</div>
							</div>

						</div>

					</div>

				</div>
			);
		}

		return (
			<Cluster>
				<Header />
				{content}
			</Cluster>
		);
	}

}

const mapStateToProps = state => {
	return {
		matter: state.matter,
		measures: state.measures,
		token: state.token,
		user: state.user
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxNewMatter: 			(token) => dispatch(actions.newMatter(token)),
		rdxToggleCounterClaim: 	() => dispatch(actions.toggleCounterClaim()),
		rdxToast: 				(text,kind) => dispatch(actions.setToast(text,kind)),
		rdxSetMatterValue: 		(item,value) => dispatch(actions.setMatterValue(item,value)),
		rdxSaveMeasures: 		(token,id,measures,has_counter,angle) => dispatch(actions.saveMeasures(token,id,measures,has_counter,angle))
	};
}



export default connect(mapStateToProps, mapDispatchToProps)(NewMatter);


// WEBPACK FOOTER //
// ./src/Pages/NewMatter.js